module.exports = __webpack_public_path__ + "assets/img/times_on.7be16431.svg";